/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { createDialogRoute } from '@gh/common-shared';
import { UserProfilePhotoBusinessService } from '../../resources';
import { UserProfilePhotoDialogComponent } from './user-profile-photo-dialog.component';

export const userProfilePhotoDialog = createDialogRoute({
  component: UserProfilePhotoDialogComponent,
  init: UserProfilePhotoBusinessService,
});
